import { Routes } from '@angular/router';
import { InviteRoutes } from './invite/invite.routes';
import { AccountBaseComponent } from './account-base.component';
import { personalInformationRoutes } from './personal-information/personal-information.routes';
import { insuranceRoutes } from './insurance/insurance.routes';
import { connectedAccountsRoutes } from './connected-accounts/connected-accounts.routes';
import { subscriptionRoutes } from './subscriptions/subscription.routes';

export const accountRoutes: Routes = [
  {
    path: 'invite',
    loadComponent: () => import('./invite/invite.page').then((m) => m.InvitePage),
    children: InviteRoutes,
  },
  {
    path: '',
    component: AccountBaseComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./account-settings/account-settings.page').then((m) => m.AccountSettingsPage),
      },
      {
        path: 'personal-information',
        loadComponent: () =>
          import('./personal-information/personal-information.page').then((m) => m.PersonalInformationPage),
        children: personalInformationRoutes,
        data: {
          shouldShowTabBar: false,
        },
      },
      {
        path: 'insurance',
        loadComponent: () => import('./insurance/insurance.page').then((m) => m.InsurancePage),
        children: insuranceRoutes,
        data: {
          shouldShowTabBar: false,
        },
      },
      {
        path: 'pharmacy',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./preferred-pharmacy/preferred-pharmacy.page').then((m) => m.PreferredPharmacyPage),
            data: {
              shouldShowTabBar: false,
            },
          },
          {
            path: 'search',
            loadComponent: () =>
              import(
                './preferred-pharmacy/pharmacy-search/account-pharmacy-search/account-pharmacy-search.component'
              ).then((m) => m.AccountPharmacySearchComponent),
            data: {
              shouldShowTabBar: false,
            },
          },
          {
            path: 'preview',
            loadComponent: () =>
              import(
                './preferred-pharmacy/pharmacy-preview/account-pharmacy-preview/account-pharmacy-preview.component'
              ).then((m) => m.AccountPharmacyPreviewComponent),
            data: {
              shouldShowTabBar: false,
            },
          },
        ],
      },
      {
        path: 'subscriptions',
        children: subscriptionRoutes,
        data: {
          shouldShowTabBar: false,
        },
      },
      {
        path: 'connected',
        loadComponent: () =>
          import('./connected-accounts/connected-accounts.page').then((m) => m.ConnectedAccountsPage),
        children: connectedAccountsRoutes,
        data: {
          shouldShowTabBar: false,
        },
      },
      {
        path: 'contact-information',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./contact-information/contact-information.component').then((m) => m.ContactInformationComponent),
            data: {
              shouldShowTabBar: false,
            },
          },
          {
            path: 'review-contact-info',
            loadComponent: () =>
              import('./contact-information/review-contact-info/review-contact-info.component').then(
                (m) => m.ReviewContactInfoComponent,
              ),
            data: {
              shouldShowTabBar: false,
            },
          },
          {
            path: 'review-address-info',
            loadComponent: () =>
              import('./contact-information/review-address-info/review-address-info.component').then(
                (m) => m.ReviewAddressInfoComponent,
              ),
            data: {
              shouldShowTabBar: false,
            },
          },
          {
            path: 'verify-contact-info',
            loadComponent: () =>
              import('./contact-information/verify-contact-info/verify-contact-info.component').then(
                (m) => m.VerifyContactInfoComponent,
              ),
            data: {
              shouldShowTabBar: false,
            },
          },
          {
            path: 'confirm-contact-info',
            loadComponent: () =>
              import('./contact-information/confirm-contact-info/confirm-contact-info.component').then(
                (m) => m.ConfirmContactInfoComponent,
              ),
            data: {
              shouldShowTabBar: false,
            },
          },
          {
            path: 'address-contact-info',
            loadComponent: () =>
              import('./contact-information/address-contact-info/address-contact-info.component').then(
                (m) => m.AddressContactInfoComponent,
              ),
            data: {
              shouldShowTabBar: false,
            },
          },
          {
            path: ':type',
            loadComponent: () =>
              import('./contact-information/update-contact-info/update-contact-info.component').then(
                (m) => m.UpdateContactInfoComponent,
              ),
            data: {
              shouldShowTabBar: false,
            },
          },
        ],
      },
      {
        path: 'medications',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./health-summary/medications/medications.component').then((m) => m.MedicationsComponent),
            data: {
              shouldShowTabBar: false,
            },
          },
        ],
      },
      {
        path: 'medical-history',
        loadComponent: () =>
          import('./health-summary/medical-history/medical-history.component').then((m) => m.MedicalHistoryComponent),
        data: {
          shouldShowTabBar: false,
        },
      },
      {
        path: 'lab-results',
        loadComponent: () =>
          import('./health-summary/lab-results/lab-results.component').then((m) => m.LabResultsComponent),
        data: {
          shouldShowTabBar: false,
        },
      },
      {
        path: 'documents',
        loadComponent: () => import('./health-summary/documents/documents.component').then((m) => m.DocumentsComponent),
        data: {
          shouldShowTabBar: false,
        },
      },
    ],
  },
];
